import { useRegisterCortexContext } from "@via/hooks/useRegisterCortexContext";
import { ROUTES } from "@via/utils/constants.tsx";

interface UseRegisterProcessScriptsCortexContextsParams {
  getContext: () => Record<string, any>;
  enabled: boolean;
}

export function useRegisterProcessScriptsCortexContexts({
  getContext,
  enabled,
}: UseRegisterProcessScriptsCortexContextsParams): void {
  // We intentionally call the hook 3 times (no loops) to keep React Rules of Hooks safe.
  useRegisterCortexContext({
    routePattern: ROUTES.PIPELINE_WORKFLOW,
    contextName: "Process Scripts",
    getContext,
    systemPrompt:
      "You are helping edit a pipeline process script. Use the selected script content and metadata to answer questions and suggest safe code changes.",
    enabled,
  });

  // CreateEditProcessForm is reused in Cortex pages (Model Garden / Model Skills).
  // Register the same scripts context on those routes so "Selected code" works there too.
  useRegisterCortexContext({
    routePattern: ROUTES.CORTEX_MODEL_SKILL,
    contextName: "Model Skill Scripts",
    getContext,
    systemPrompt:
      "You are helping edit a model skill script. Use the selected script content and metadata to answer questions and suggest safe code changes.",
    enabled,
  });

  useRegisterCortexContext({
    routePattern: ROUTES.CORTEX_MODEL_GARDEN,
    contextName: "Model Garden Scripts",
    getContext,
    systemPrompt:
      "You are helping edit a model script. Use the selected script content and metadata to answer questions and suggest safe code changes.",
    enabled,
  });
}
